import { validatePhoneNumber } from 'containers/pages/Messaging/CampaignDialog/WizardContextV3/customValidations';
import { isTCRAprovedEmail } from './validators';

const restartEmailVerificationContent = {
  title: 'Restart email verification',
  description:
    'Please confirm business email address before restarting the 2FA email verification process.',
  label: 'Business email address',
  buttonText: 'Restart email verification',
  dataTestButton: 'ChangeEmailButton',
};

const changePhoneContent = {
  title: 'Change business contact number',
  description: 'Please select the number that you use for business purposes.',
  label: 'Mobile phone number',
  buttonText: 'Change',
  dataTestButton: 'ChangePhoneNumberButton',
};

export const getOTPDialogContentRules = (variant: string) => {
  if (variant === 'restartEmailVerification') {
    return {
      content: restartEmailVerificationContent,
      rules: {
        required: 'Please enter a valid email.',
        validate: isTCRAprovedEmail,
      },
    };
  }
  return {
    content: changePhoneContent,
    rules: {
      required: 'Please enter a valid phone number.',
      validate: validatePhoneNumber,
    },
  };
};
